export default "__VITE_ASSET__BhqSI8AN__"